import type { ColDef } from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import { useMemo } from "react";
import { globalDefaultColDef } from "@/setup/ag-grid/mesf-theme";
import type { RollsByStandRow } from "../models/MillSetupSheet";

export const RollsByStandTable = ({ rows }: { rows: RollsByStandRow[] }) => {
	const columnDefs = useMemo<ColDef<RollsByStandRow>[]>(
		() => [
			{
				headerName: "Stand",
				field: "StandName",
				width: 75,
				headerTooltip: "Mill stand",
				tooltipValueGetter: () => "Mill stand",
			},
			{
				headerName: "Roll Diameter",
				field: "Diameter",
				type: "numericColumn",
				flex: 1,
				minWidth: 110,
				headerTooltip:
					"Recommended roll diameter (max of top and bottom rolls) of the rollset prepared for this stand.",
				tooltipValueGetter: (p) =>
					p.value == null
						? "No compatible prepared rollset for this stand"
						: "Recommended roll diameter (max of top and bottom rolls) of the rollset prepared for this stand",
				valueFormatter: (p) =>
					p.value == null ? "-" : Number(p.value).toFixed(3),
			},
			{
				headerName: "Cartridge",
				field: "CartridgeName",
				flex: 1.4,
				minWidth: 110,
				headerTooltip:
					"Cartridge of the rollset prepared for this stand (the recommended rollset to change to).",
				tooltipValueGetter: (p) =>
					p.value == null
						? "No compatible prepared rollset for this stand"
						: "Cartridge of the rollset prepared for this stand (the recommended rollset to change to)",
				valueFormatter: (p) => p.value ?? "-",
			},
		],
		[],
	);

	return (
		<div style={{ width: "100%", height: "100%" }}>
			<AgGridReact<RollsByStandRow>
				rowData={rows}
				columnDefs={columnDefs}
				defaultColDef={globalDefaultColDef}
				enableBrowserTooltips
				getRowId={(params) => params.data.StandId?.toString() ?? ""}
				suppressContextMenu
				animateRows={false}
				rowHeight={36}
				headerHeight={36}
				getRowStyle={(params) => {
					// Change required: green when a prepared cartridge is available,
					// red when none (matches the Next Campaigns colour logic).
					if (!params.data?.MustChange) return undefined;
					return {
						backgroundColor: params.data.CartridgeName ? "#a5d6a7" : "#ef9a9a",
					};
				}}
			/>
		</div>
	);
};
